import { render, staticRenderFns } from "./cookies-popup.vue?vue&type=template&id=512d1c36"
import script from "./cookies-popup.vue?vue&type=script&lang=js"
export * from "./cookies-popup.vue?vue&type=script&lang=js"
import style0 from "./cookies-popup.vue?vue&type=style&index=0&id=512d1c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports